// extracted by css-extract-rspack-plugin
export default {"QuestionListItem":"QuestionList-module__QuestionListItem___fkfMl","QuestionListItemIcon":"QuestionList-module__QuestionListItemIcon___X59Li"};